import apiService from '../apiService';

const MovementApi = {
  listMovement: (params) => apiService.get('/movements', params),
  getMovement: (id) => apiService.get(`/movements/${id}`),
  getMovementSummary: () => apiService.get(`/movements/movementSummary`),
  //createMovement: (data) => apiService.post('/movements', data),
  createMovementIncoming: (data) => apiService.post('/movements/incoming', data),
  createMovementOutgoing: (data) => apiService.post('/movements/outgoing', data),
  //updateMovement: (id, data) => apiService.put(`/movements/${id}`, data),
  updateMovementIncoming: (id, data) => apiService.put(`/movements/incoming/${id}`, data),
  updateMovementOutgoing: (id, data) => apiService.put(`/movements/outgoing/${id}`, data),
  deleteMovement: (id) => apiService.delete(`/movements/${id}`),
};

export default MovementApi;
